module.exports = __webpack_public_path__ + "6d8ddcbcbad2c9c0650c51dc5bc903ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/plugin/images/plugin-img002.png
// module id = 912
// module chunks = 3